import { render } from "./ListPricesAdminComponent.vue?vue&type=template&id=6b573f31"
import script from "./ListPricesAdminComponent.vue?vue&type=script&lang=js"
export * from "./ListPricesAdminComponent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__